import { Component, inject, signal } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { StateService } from './services/state';
import { LoaderComponent } from './components/loader.component';
import { Api } from './services/api';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, LoaderComponent],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App {
  protected readonly title = signal('cotitzador');
  private readonly stateService = inject(StateService);
  private readonly router = inject(Router);
  private readonly route = inject(ActivatedRoute);
  private readonly api = inject(Api);

  constructor() {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.api.post('/stats/path', { path: event.url, origin: 'pordias' }).subscribe();
      }
    });
  }

  ngOnInit() {
    const state = this.stateService.getState();

    const queryParams = new URLSearchParams(window.location.search);

    let additionalState = {
      campaign_id: state.campaign_id,
      collaborator_id: state.collaborator_id,
    };

    if (queryParams.get('campaign_id')) {
      additionalState['campaign_id'] = queryParams.get('campaign_id');
    }

    if (queryParams.get('collaborator_id')) {
      additionalState['collaborator_id'] = queryParams.get('collaborator_id');
    }

    this.stateService.setState({ ...state, ...additionalState });
  }
}
